import React from 'react';
import Footer from '../Footer';
import TopHeader from '../HeaderButton/TopHeader';
const Layout = ({children}) => {
    return (  
        <div className='app-shell flex min-h-screen flex-col'>
   <TopHeader/>
   <main className="flex-1">{children}</main>
    <Footer/>
  </div>
    );
}
 
export default Layout;
